<template>
  <div>
    <div class="loading" v-if="loading" style="margin: 50% 0">
      <van-loading type="circular" color="#999" />
    </div>
    <div v-if="!loading">
      <section>
        <div class="header">
          <van-nav-bar
            :title="newData.title"
            left-text=" "
            left-arrow
            @click-left="onClickLeft"
          >
            <template #right>
              <span
                v-if="previewStatusConfig"
                class="article-status"
                :style="{ color: previewStatusConfig.color }"
              >
                状态：{{ previewStatusConfig.label }}
              </span>
            </template>
          </van-nav-bar>
          <div class="live-video-wrap">
            <video
              ref="liveVideo"
              class="live-video hls-video-player"
              controls
              playsinline
              webkit-playsinline
              :poster="newData.videoCover"
            ></video>
          </div>
          <!-- <div class="zbtitle">{{ newData.title }}</div> -->
          <div
            v-if="keywordHighlightEnabled && highlightedSummaryHtml"
            class="desc"
            v-html="highlightedSummaryHtml"
          ></div>
          <div v-else class="desc">
            {{ newData.summary }}
          </div>
        </div>
      </section>

      <section class="cd-container" style="background: #eee">
        <div class="live-item" v-for="(v, k) in liveList" :key="k">
          <div class="my-video" style="margin: 0 15px 15px"></div>
          <div class="time">{{ formatTimeAgo(v.publishedDate) }}</div>
          <div class="message" v-html="processLiveItemContent(v)"></div>
        </div>
      </section>
    </div>

    <footer1></footer1>

    <div
      v-if="keywordTip.show"
      id="keyword-tip"
      class="keyword-tip"
      :style="{ left: keywordTip.left + 'px', top: keywordTip.top + 'px' }"
    >
      <div class="keyword-tip-title">触发关键字</div>
      <div
        v-for="group in keywordTip.groups"
        :key="group.type"
        class="keyword-tip-item"
      >
        <div class="keyword-tip-label">{{ group.label }}：</div>
        <div class="keyword-tip-list">
          <span
            v-for="(kw, index) in group.keywords"
            :key="group.type + '-' + index"
            class="keyword-tip-tag"
            :style="{ backgroundColor: group.bg, color: group.color }"
          >
            {{ kw }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import footer1 from "@/components/footer";
import { getLiveArticleVo, checkContent } from "../commJs/articles";
import { wechatShare } from "../commJs/wechat";
import {
  setupHlsVideo,
  destroyHlsVideo,
  processContentVideos,
  initContentVideoPlayers,
} from "../commJs/video";
import previewWatermarkMixin from "../commJs/previewWatermarkMixin";
import keywordHighlightMixin, {
  htmlToPlainText,
  parseKeywordGroups,
} from "../commJs/keywordHighlightMixin";
import { highlightHtml } from "../commJs/keyword";
import { getArticleStatusConfig } from "../constants";

export default {
  mixins: [previewWatermarkMixin, keywordHighlightMixin],
  data() {
    return {
      loading: true,
      newData: {},
      errorT: "",
      cleanupLiveListVideos: null,
      highlightedSummaryHtml: "",
      highlightedFrameContentMap: {},
    };
  },
  components: {
    footer1,
  },
  computed: {
    queryKey() {
      const key = this.$route.query.key;
      return typeof key === "string" && key.trim() ? key.trim() : undefined;
    },
    isPreviewMode() {
      return Boolean(this.queryKey);
    },
    /**
     * 直播帧目标 id（Temp type=4 跳转时通过 query.id 传入）。
     */
    targetFrameId() {
      const id = this.$route.query.id;
      return typeof id === "string" && id.trim() ? id.trim() : "";
    },
    /**
     * 是否按单帧敏感词模式处理（from=wechat 且带帧 id）。
     */
    isFrameHighlightMode() {
      return this.isFromWechat && Boolean(this.targetFrameId);
    },
    liveList() {
      return Array.isArray(this.newData.liveList) ? this.newData.liveList : [];
    },
    /**
     * 预览态稿件状态：单帧模式取对应帧 status，否则取直播稿 status。
     */
    previewStatusConfig() {
      if (!this.isPreviewMode) return undefined;
      if (this.isFrameHighlightMode) {
        const frame = this.liveList.find((item) =>
          this.isMatchingFrame(item, this.targetFrameId),
        );
        return getArticleStatusConfig(
          (frame && frame.status) != null
            ? frame.status
            : this.newData && this.newData.status,
        );
      }
      return getArticleStatusConfig(this.newData && this.newData.status);
    },
  },
  methods: {
    /**
     * 判断时间轴条目是否匹配目标直播帧 id。
     * @param {Record<string, unknown>} item
     * @param {string} frameId
     * @returns {boolean}
     */
    isMatchingFrame(item, frameId) {
      if (!frameId) return false;
      const candidates = [
        item && item.id,
        item && item.articleId,
        item && item.article_id,
      ];
      return candidates.some(function (value) {
        return String(value == null ? "" : value) === frameId;
      });
    },
    /**
     * 获取时间轴条目展示用 HTML（命中单帧高亮时返回高亮结果）。
     * @param {Record<string, unknown>} item
     * @returns {string}
     */
    getTimelineContentHtml(item) {
      const raw = String((item && item.content) || "");
      if (!this.keywordHighlightEnabled || !this.isFrameHighlightMode) {
        return raw;
      }
      const frameId = String(
        (item &&
          (item.id != null
            ? item.id
            : item.articleId != null
            ? item.articleId
            : item.article_id)) ||
          "",
      );
      return this.highlightedFrameContentMap[frameId] || raw;
    },
    processLiveItemContent(item) {
      return processContentVideos(this.getTimelineContentHtml(item) || "");
    },
    clearKeywordHighlight() {
      this.resetKeywordTipState();
      this.highlightedSummaryHtml = "";
      this.highlightedFrameContentMap = {};
    },
    /**
     * 预览且 from=wechat：
     * - 带 query.id：只高亮匹配的直播帧正文
     * - 不带 id：高亮直播摘要
     */
    async applyLiveKeywordHighlight() {
      this.highlightedSummaryHtml = "";
      this.highlightedFrameContentMap = {};

      if (!this.shouldHighlightKeywords) {
        this.clearKeywordHighlight();
        return;
      }

      try {
        if (this.isFrameHighlightMode) {
          const frameId = this.targetFrameId;
          const frame = this.liveList.find((item) =>
            this.isMatchingFrame(item, frameId),
          );
          if (!frame) {
            this.clearKeywordHighlight();
            return;
          }
          const content = String(frame.content || "").trim();
          if (!content) {
            this.clearKeywordHighlight();
            return;
          }
          const payload = await checkContent(htmlToPlainText(content), "gjms");
          const groups = parseKeywordGroups(payload);
          this.keywordData = groups;
          const highlighted = highlightHtml(content, groups);
          const mapKey = String(
            frame.id != null
              ? frame.id
              : frame.articleId != null
              ? frame.articleId
              : frame.article_id != null
              ? frame.article_id
              : frameId,
          );
          this.highlightedFrameContentMap = { [mapKey]: highlighted };
          this.keywordHighlightEnabled = true;
          return;
        }

        const summary = String(this.newData.summary || "").trim();
        if (!summary) {
          this.clearKeywordHighlight();
          return;
        }
        const payload = await checkContent(htmlToPlainText(summary), "gjms");
        const groups = parseKeywordGroups(payload);
        this.keywordData = groups;
        this.highlightedSummaryHtml = highlightHtml(summary, groups);
        this.keywordHighlightEnabled = true;
      } catch (error) {
        console.error("关键词检测失败:", error);
        this.clearKeywordHighlight();
      }
    },
    bindLiveVideo(src) {
      this.$nextTick(() => {
        const video = this.$refs.liveVideo;
        if (video && src) {
          setupHlsVideo(video, src);
        }
      });
    },
    initLiveListVideos() {
      this.$nextTick(() => {
        if (this.cleanupLiveListVideos) {
          this.cleanupLiveListVideos();
          this.cleanupLiveListVideos = null;
        }
        const cleanups = [];
        this.$el
          .querySelectorAll(".cd-container .message")
          .forEach((container) => {
            cleanups.push(initContentVideoPlayers(container));
          });
        this.cleanupLiveListVideos = () => {
          cleanups.forEach((cleanup) => cleanup());
        };
      });
    },
    formatTimeAgo(time) {
      if (!time) return "";
      const date = new Date(String(time));
      if (Number.isNaN(date.getTime())) return "";

      const now = new Date();
      const sameYear = now.getFullYear() === date.getFullYear();
      const sameMonth = sameYear && now.getMonth() === date.getMonth();
      const sameDay = sameMonth && now.getDate() === date.getDate();

      if (sameDay) {
        const diffMs = Math.max(now.getTime() - date.getTime(), 0);
        const hours = Math.floor(diffMs / (60 * 60 * 1000));
        return `${Math.max(hours, 1)}小时前`;
      }

      if (sameMonth) {
        const startOfNow = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
        ).getTime();
        const startOfDate = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
        ).getTime();
        const days = Math.max(
          Math.floor((startOfNow - startOfDate) / (24 * 60 * 60 * 1000)),
          1,
        );
        return `${days}天前`;
      }

      if (sameYear) {
        const months = Math.max(now.getMonth() - date.getMonth(), 1);
        return `${months}月前`;
      }

      return `${date.getFullYear()}年${
        date.getMonth() + 1
      }月${date.getDate()}日`;
    },
    async getView(id) {
      try {
        const data = await getLiveArticleVo(id, this.queryKey);
        this.newData = data || {};
        this.loading = false;
        if (this.newData.title) {
          document.title = this.newData.title;
          wechatShare(this.newData.title);
        }
        this.bindLiveVideo(this.newData.videoLink);
        await this.applyLiveKeywordHighlight();
        this.initLiveListVideos();
      } catch (error) {
        this.errorT = "加载直播详情失败";
        this.loading = false;
      }
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  beforeDestroy() {
    const video = this.$refs.liveVideo;
    if (video) {
      destroyHlsVideo(video);
    }
    if (this.cleanupLiveListVideos) {
      this.cleanupLiveListVideos();
      this.cleanupLiveListVideos = null;
    }
  },
  watch: {
    $route() {
      this.clearKeywordHighlight();
      this.id = this.$route.params.id || 0;
      if (!this.id || this.id == 0) {
        this.error = "该文章不存在";
      } else {
        this.loading = true;
        this.getView(this.id);
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id || 0;
    if (!this.id || this.id == 0) {
      this.error = "该文章不存在";
    } else {
      this.getView(this.id);
    }
  },
};
</script>

<style scoped lang="less">
img {
  width: 100% !important;
  height: auto !important ;
}
.header {
  background: #fff;
}
.article-status {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.contents {
  min-height: 60vh;
}
.zbtitle {
  padding: 20px;
  color: #000;
  background: #fff;
  font-size: 18px;
  font-weight: bold;
  margin-top: 0;
}
.desc {
  padding: 20px;
  // padding-top: 0;
  color: #999;
  background: #fff;
  font-size: 14px;
}
.photocentent {
  padding: 10px;
}

.live-video-wrap {
  width: 100%;
  height: 208px;
  margin-top: 10px;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.live-video {
  width: 100%;
  height: auto;
  max-height: 208px;
  // object-fit: cover;
  object-position: center center;
  display: block;
  background: #000;
}

.title {
  padding: 10px;
  font-size: 18px;
  color: #3a60e1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  position: relative;
  padding-left: 20px;
  background: #eee;

  &:after {
    content: "";
    position: absolute;
    height: 15px;
    width: 2px;
    background: #3a60e1;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.cd-container {
  font-size: 14px;

  .live-item {
    padding: 5px;
    border-radius: 5px;
    border-bottom: 1px solid #ddd;
    .time {
      color: #999;
      margin-bottom: 15px;
      padding-left: 35px;
      position: relative;
      &:after {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 15px;
        width: 8px;
        height: 8px;
        background: #07c160;
        border-radius: 8px;
        content: "";
      }
    }
    .message {
      line-height: 30px;
      color: #333;
      font-size: 16px;
      padding: 0px;
    }
  }
}
</style>

<style lang="less">
.kw-highlight,
span[data-highlight="yes"] {
  display: inline-block;
  line-height: 2;
  cursor: pointer;
  position: relative;
  border-radius: 2px;
}

.keyword-tip {
  position: fixed;
  z-index: 10000;
  padding: 12px;
  max-width: 280px;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
  color: #606266;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  word-break: break-all;
  pointer-events: none;
}

.keyword-tip-title {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #303133;
}

.keyword-tip-label {
  margin-bottom: 4px;
  font-weight: 600;
}

.keyword-tip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.keyword-tip-tag {
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  height: 24px;
  padding: 0 10px;
  line-height: 24px;
}
</style>
<style lang="less" scoped>
::v-deep .van-nav-bar__right {
  padding: 0;
}
</style>
